<ng-template [ngTemplateOutlet]="tooltipTemplate"></ng-template>
